import { render, staticRenderFns } from "./ClientFigures.vue?vue&type=template&id=77f3b20a"
import script from "./ClientFigures.vue?vue&type=script&lang=js"
export * from "./ClientFigures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports